module.exports = __webpack_public_path__ + "static/media/bv.b884cec9.svg";